import flatpickr from "flatpickr"
import { Swedish } from "flatpickr/dist/l10n/sv"
import { format } from "date-fns"

import init from "../../shared/utils/init"

// form date picker

init(() => {
  const picker = document.querySelector(`.activities-page-form__date__picker`)
  const inputs = document.querySelector(`.activities-page-form__date__inputs`)
  const inputStart = document.querySelector(
    `.js--activities-page-form-date-start`
  )
  const inputEnd = document.querySelector(`.js--activities-page-form-date-end`)

  if (!picker || !inputs || !inputStart || !inputEnd) return

  const actDates = JSON.parse(picker.dataset.dateCounts)

  inputs.classList.add(`is-vhidden`)

  const defaultDate =
    inputStart.value && inputEnd.value ? [inputStart.value, inputEnd.value] : []

  flatpickr(picker, {
    defaultDate,
    inline: true,
    mode: `range`,
    locale: Swedish,
    onChange: (selectedDates) => {
      const dates = selectedDates.map((d) => format(d, `yyyy-MM-dd`))
      inputStart.value = dates[0]
      inputEnd.value = dates[1]
    },
    onDayCreate: function (dObj, dStr, fp, dayElem) {
      if (actDates.includes(format(dayElem.dateObj, `yyyy-MM-dd`))) {
        dayElem.innerHTML += `<span class='pin'></span>`
      }
    },
  })
})
